import { AccountPlan } from '@/constants/enum';

export const generateDiscountPlan = (plans: AccountPlan[], getPlanName: (plan: AccountPlan) => string): string => {
  const filteredPlans = plans.filter((plan) => plan !== AccountPlan.Starter);
  if (filteredPlans.length === Object.keys(AccountPlan).length - 1) {
    return 'all';
  }
  return filteredPlans.map((plan) => getPlanName(plan)).join(', ');
};
